import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useNavigate, useParams } from "react-router-dom";

const StaffDetailsUpdateForm = () => {
  const { id } = useParams(); // Get the student ID from the URL
  const [formData, setFormData] = useState({
    personalDetails: {
      staffId: "",
      staffName: "",
      dob: "",
      gender: "",
      contactNumber: "",
      whatsappNumber: "",
      emailAddress: "",
      address: "",
      aadharNumber: "",
      bankDetails: {
        accountNumber: "",
        ifscCode: "",
        branch: "",
        upiId: "",
      },
    },
    educationalDetails: {
      tenth: { board: "", percentage: "" },
      twelfth: { board: "", percentage: "" },
      graduation: { board: "", percentage: "" },
      postGraduation: { board: "", percentage: "" },
    },
    professionalDetails: {
      designation: "",
      class: "",
      yearOfExperience: "",
      expertiseSubject: "",
      salary: "",
      totalLeaves: "",
      employeeType: "",
    },
  });

  useEffect(() => {
    // Fetch student data to pre-fill the form
    const fetchStaffData = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("token"));
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/staffs/fetch/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200) {
          setFormData(response.data); // Set the form data with the fetched student details
        } else {
          toast.error("Failed to fetch student data.");
        }
      } catch (error) {
        toast.error("An error occurred while fetching student data.");
      }
    };

    fetchStaffData();
  }, []);

  const navigate = useNavigate();

  const handleChange = (e, section, subSection) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      if (subSection) {
        return {
          ...prev,
          [section]: {
            ...prev[section],
            [subSection]: {
              ...prev[section][subSection],
              [name]: value,
            },
          },
        };
      }
      return {
        ...prev,
        [section]: {
          ...prev[section],
          [name]: value,
        },
      };
    });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await axios.patch(
        `${process.env.REACT_APP_API_URL}/staffs/update/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        toast.success("Staff Details updated successfully!");
        window.scrollTo({ top: 0, behavior: "smooth" });
        setTimeout(() => {
          navigate(`/erp/staffs/list`);
        }, 2000);
      } else {
        toast.error("Failed to update staff details. Please try again.");
      }
    } catch (error) {
      toast.error("An error occurred. Please check your input and try again.");
    }
  };

  return (
    <>
      <div className="container mt-5 bg-white rounded p-5 mb-5">
        <div className="row">
          <div className="col-12 d-flex justify-content-between align-items-center">
            <Link to="/erp/staffs/list" className="btn btn-secondary mb-3">
              &#8592; Back to Staff List
            </Link>
            <h3 className="text-center text-success">Update Staff Details</h3>
          </div>
          <div className="text-center d-flex justify-content-end">
            <h5>Staff ID - {id}</h5>
          </div>
        </div>
        <form onSubmit={handleUpdate}>
          {/* Personal Details */}
          <h4>Personal Details</h4>
          <div className="row g-3 mt-3">
            <div className="col-md-4">
              <label className="form-label">Staff Name *</label>
              <input
                type="text"
                className="form-control"
                name="staffName"
                required
                value={formData.personalDetails.staffName}
                onChange={(e) => handleChange(e, "personalDetails")}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Date of Birth *</label>
              <input
                type="date"
                className="form-control"
                name="dob"
                required
                value={formData.personalDetails.dob}
                onChange={(e) => handleChange(e, "personalDetails")}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Gender *</label>
              <select
                className="form-control"
                name="gender"
                required
                value={formData.personalDetails.gender}
                onChange={(e) => handleChange(e, "personalDetails")}
              >
                <option value="">Select</option>
                <option value="MALE">Male</option>
                <option value="FEMALE">Female</option>
              </select>
            </div>
          </div>

          <div className="row g-3 mt-3">
            <div className="col-md-4">
              <label className="form-label">Contact Number *</label>
              <input
                type="text"
                className="form-control"
                name="contactNumber"
                required
                value={formData.personalDetails.contactNumber}
                onChange={(e) => handleChange(e, "personalDetails")}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">WhatsApp Number *</label>
              <input
                type="text"
                className="form-control"
                name="whatsappNumber"
                value={formData.personalDetails.whatsappNumber}
                onChange={(e) => handleChange(e, "personalDetails")}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Email Address *</label>
              <input
                type="email"
                className="form-control"
                name="emailAddress"
                required
                value={formData.personalDetails.emailAddress}
                onChange={(e) => handleChange(e, "personalDetails")}
              />
            </div>
          </div>
          <div className="row g-3 mt-3">
            <div className="col-md-4">
              <label className="form-label">Aadhar Number *</label>
              <input
                type="text"
                className="form-control"
                name="aadharNumber"
                required
                value={formData.personalDetails.aadharNumber}
                onChange={(e) => handleChange(e, "personalDetails")}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Address *</label>
              <input
                type="text"
                className="form-control"
                name="address"
                required
                value={formData.personalDetails.address}
                onChange={(e) => handleChange(e, "personalDetails")}
              />
            </div>
          </div>

          {/* Bank Details */}
          <h5 className="mt-4">Bank Details</h5>
          <div className="row g-3 mt-3">
            <div className="col-md-4">
              <label className="form-label">Account Number</label>
              <input
                type="text"
                className="form-control"
                name="accountNumber"
                required
                value={formData.personalDetails.bankDetails.accountNumber}
                onChange={(e) =>
                  handleChange(e, "personalDetails", "bankDetails")
                }
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">IFSC Code</label>
              <input
                type="text"
                className="form-control"
                name="ifscCode"
                required
                value={formData.personalDetails.bankDetails.ifscCode}
                onChange={(e) =>
                  handleChange(e, "personalDetails", "bankDetails")
                }
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Branch</label>
              <input
                type="text"
                className="form-control"
                name="branch"
                required
                value={formData.personalDetails.bankDetails.branch}
                onChange={(e) =>
                  handleChange(e, "personalDetails", "bankDetails")
                }
              />
            </div>
          </div>
          <div className="row g-3 mt-3">
            <div className="col-md-4">
              <label className="form-label">UPI ID</label>
              <input
                type="text"
                className="form-control"
                name="upiId"
                value={formData.personalDetails.bankDetails.upiId}
                onChange={(e) =>
                  handleChange(e, "personalDetails", "bankDetails")
                }
              />
            </div>
          </div>

          {/* Educational Details */}
          <h4 className="mt-5">Educational Details</h4>
          <div className="my-3">
            <h6>10th</h6>
            <div className="row">
              <div className="col-md-6">
                <label className="form-label">Board *</label>
                <input
                  type="text"
                  className="form-control"
                  name="board"
                  value={formData.educationalDetails.tenth.board}
                  onChange={(e) =>
                    handleChange(e, "educationalDetails", "tenth")
                  }
                  required
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Percentage *</label>
                <input
                  type="number"
                  className="form-control"
                  name="percentage"
                  value={formData.educationalDetails.tenth.percentage}
                  onChange={(e) =>
                    handleChange(e, "educationalDetails", "tenth")
                  }
                  required
                />
              </div>
            </div>
          </div>

          <div className="my-3">
            <h6>12th</h6>
            <div className="row">
              <div className="col-md-6">
                <label className="form-label">Board *</label>
                <input
                  type="text"
                  className="form-control"
                  name="board"
                  value={formData.educationalDetails.twelfth.board}
                  onChange={(e) =>
                    handleChange(e, "educationalDetails", "twelfth")
                  }
                  required
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Percentage *</label>
                <input
                  type="number"
                  className="form-control"
                  name="percentage"
                  value={formData.educationalDetails.twelfth.percentage}
                  onChange={(e) =>
                    handleChange(e, "educationalDetails", "twelfth")
                  }
                  required
                />
              </div>
            </div>
          </div>

          <div className="my-3">
            <h6>Graduation</h6>
            <div className="row">
              <div className="col-md-6">
                <label className="form-label">Board</label>
                <input
                  type="text"
                  className="form-control"
                  name="board"
                  value={formData.educationalDetails.graduation.board}
                  onChange={(e) =>
                    handleChange(e, "educationalDetails", "graduation")
                  }
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Percentage</label>
                <input
                  type="number"
                  className="form-control"
                  name="percentage"
                  value={formData.educationalDetails.graduation.percentage}
                  onChange={(e) =>
                    handleChange(e, "educationalDetails", "graduation")
                  }
                />
              </div>
            </div>
          </div>

          <div className="my-3">
            <h6>Post Graduation</h6>
            <div className="row">
              <div className="col-md-6">
                <label className="form-label">Board</label>
                <input
                  type="text"
                  className="form-control"
                  name="board"
                  value={formData.educationalDetails.postGraduation.board}
                  onChange={(e) =>
                    handleChange(e, "educationalDetails", "postGraduation")
                  }
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Percentage</label>
                <input
                  type="number"
                  className="form-control"
                  name="percentage"
                  value={formData.educationalDetails.postGraduation.percentage}
                  onChange={(e) =>
                    handleChange(e, "educationalDetails", "postGraduation")
                  }
                />
              </div>
            </div>
          </div>

          {/* Professional Details */}
          <h4 className="mt-5">Professional Details</h4>
          <div className="row g-3 mt-3">
            <div className="col-md-4">
              <label className="form-label">Designation *</label>
              <input
                type="text"
                className="form-control"
                name="designation"
                required
                value={formData.professionalDetails.designation}
                onChange={(e) => handleChange(e, "professionalDetails")}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Class Taken *</label>
              <input
                type="text"
                className="form-control"
                name="class"
                required
                value={formData.professionalDetails.class}
                onChange={(e) => handleChange(e, "professionalDetails")}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Years of Experience *</label>
              <input
                type="number"
                className="form-control"
                name="yearOfExperience"
                required
                value={formData.professionalDetails.yearOfExperience}
                onChange={(e) => handleChange(e, "professionalDetails")}
              />
            </div>
          </div>
          <div className="row g-3 mt-3">
            <div className="col-md-4">
              <label className="form-label">Expertise Subject *</label>
              <input
                type="text"
                className="form-control"
                name="expertiseSubject"
                required
                value={formData.professionalDetails.expertiseSubject}
                onChange={(e) => handleChange(e, "professionalDetails")}
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">Salary (in Rupees) *</label>
              <input
                type="number"
                className="form-control"
                name="salary"
                required
                value={formData.professionalDetails.salary}
                onChange={(e) => handleChange(e, "professionalDetails")}
              />
            </div>

            <div className="col-md-4">
              <label className="form-label">Employee Type *</label>
              <select
                className="form-control"
                name="employeeType"
                required
                value={formData.professionalDetails.employeeType}
                onChange={(e) => handleChange(e, "professionalDetails")}
              >
                <option value="">Select</option>
                <option value="TEACHING">Teaching</option>
                <option value="NON-TEACHING">Non-Teaching</option>
                <option value="ADMINISTRATIVE">Administrative</option>
              </select>
            </div>
          </div>

          <div className="d-grid gap-2 d-flex justify-content-center mt-4">
            <button type="submit" className="btn btn-success">
              Update
            </button>
          </div>
        </form>

        <ToastContainer />
      </div>
    </>
  );
};

export default StaffDetailsUpdateForm;
